module.exports = __webpack_public_path__ + "static/img/rppghealthapp5.3f6955e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthapp5.png
// module id = iztx
// module chunks = 5